/* eslint-disable react/jsx-pascal-case */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import * as Icon from 'react-feather';
class HeaderNewMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            settingsDropdown: false,
            orderDropdown: false,
            chequeDropdown: false,
            mainMenuDisplay: false,
            dashboardDropdown: false,
        };
    }
    dashboardToggle = () => {
        this.setState((prevState) => ({
            dashboardDropdown: !prevState.dashboardDropdown,
        }));
    };

    settingsToggle = () => {
        this.setState((prevState) => ({
            settingsDropdown: !prevState.settingsDropdown,
        }));
    };
    orderToggle = () => {
        this.setState((prevState) => ({
            orderDropdown: !prevState.orderDropdown,
        }));
    };
    chequeToggle = () => {
        this.setState((prevState) => ({
            chequeDropdown: !prevState.chequeDropdown,
        }));
    };
    mainMenuToggle = () => {
        this.setState((prevState) => ({
            mainMenuDisplay: !prevState.mainMenuDisplay,
        }));
    };
    render() {
        let currentPage = this.props.location.pathname.split('/')[2];
        let subPage = this.props.location.pathname.split('/')[3];
        let user_type = localStorage.user_type;
        return (
            <>
                <button className="btn mainMenuToggler mr-auto custom-nav-toggler" onClick={this.mainMenuToggle}>
                    <Icon.Menu />
                </button>
                <div
                    className={
                        'custom-navbar-overlay ' + (this.state.mainMenuDisplay === true ? ' d-block ' : 'd-none')
                    }
                    onClick={this.mainMenuToggle}
                ></div>
                <ul
                    // className="custom-navbar nav navbar-nav mx-auto pl-xl-2"
                    className={
                        'custom-navbar nav navbar-nav mx-auto pl-xl-2 ' +
                        (this.state.mainMenuDisplay === true ? ' show ' : '')
                    }
                    id="main-menu-navigation"
                >
                    {user_type === '1' ? (
                        <li
                            className={'nav-item ' + (currentPage === 'dashboard' ? 'active' : '')}
                            onMouseEnter={this.dashboardToggle}
                            onMouseLeave={this.dashboardToggle}
                        >
                            <div className="nav-item-wrapper cursor-pointer single-item">
                                <Dropdown
                                    className="py-0"
                                    isOpen={this.state.dashboardDropdown}
                                    toggle={this.dashboardToggle}
                                >
                                    <Link onClick={this.mainMenuToggle} to={`${process.env.PUBLIC_URL}/dashboard`}>
                                        <DropdownToggle caret className="btn-primary">
                                            <span className="menu-icon align-middle mr-75">
                                                <Icon.Home size={20} />
                                            </span>
                                            <span className="menu-title align-middle">Dashboard</span>
                                            <Icon.ChevronDown />
                                        </DropdownToggle>
                                    </Link>
                                    <DropdownMenu className="header-sub-menu">
                                        {user_type === '1' ? (
                                            <>
                                                <Link
                                                    onClick={this.mainMenuToggle}
                                                    to={`${process.env.PUBLIC_URL}/revenue-reports`}
                                                >
                                                    <DropdownItem
                                                        className={currentPage === 'revenue-reports' ? 'active' : ''}
                                                    >
                                                        <Icon.FileText size={12} />
                                                        <span className="menu-title align-middle">Revenue Reports</span>
                                                    </DropdownItem>
                                                </Link>
                                                <Link
                                                    onClick={this.mainMenuToggle}
                                                    to={`${process.env.PUBLIC_URL}/least-product-sales-reports`}
                                                >
                                                    <DropdownItem
                                                        className={
                                                            currentPage === 'least-product-sales-reports'
                                                                ? 'active'
                                                                : ''
                                                        }
                                                    >
                                                        <Icon.FileText size={12} />
                                                        <span className="menu-title align-middle">
                                                            Least Product Sales Reports
                                                        </span>
                                                    </DropdownItem>
                                                </Link>
                                                <Link
                                                    onClick={this.mainMenuToggle}
                                                    to={`${process.env.PUBLIC_URL}/comparison-chart-reports`}
                                                >
                                                    <DropdownItem
                                                        className={
                                                            currentPage === 'comparison-chart-reports' ? 'active' : ''
                                                        }
                                                    >
                                                        <Icon.FileText size={12} />
                                                        <span className="menu-title align-middle">
                                                            Comparison Chart Report
                                                        </span>
                                                    </DropdownItem>
                                                </Link>
                                                <Link
                                                    onClick={this.mainMenuToggle}
                                                    to={`${process.env.PUBLIC_URL}/sales-performance-reports`}
                                                >
                                                    <DropdownItem
                                                        className={
                                                            this.props.location.pathname.includes(
                                                                'sales-performance-reports',
                                                            )
                                                                ? 'active'
                                                                : ''
                                                        }
                                                    >
                                                        <Icon.FileText size={12} />
                                                        <span className="menu-title align-middle">
                                                            Sales Rep Performance Report
                                                        </span>
                                                    </DropdownItem>
                                                </Link>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                        </li>
                    ) : user_type === '3' ? (
                        <li className={'nav-item ' + (currentPage === 'salesman' ? 'active' : '')}>
                            <div className="nav-item-wrapper cursor-pointer single-item">
                                <Link onClick={this.mainMenuToggle} to={`${process.env.PUBLIC_URL}/salesman/dashboard`}>
                                    <DropdownToggle caret className="btn-primary">
                                        <span className="menu-icon align-middle mr-75">
                                            <Icon.Home size={20} />
                                        </span>
                                        <span className="menu-title align-middle">Dashboard</span>
                                    </DropdownToggle>
                                </Link>
                            </div>
                        </li>
                    ) : user_type === '4' ? (
                        <li className={'nav-item ' + (currentPage === 'driver' ? 'active' : '')}>
                            <div className="nav-item-wrapper cursor-pointer single-item">
                                <Link onClick={this.mainMenuToggle} to={`${process.env.PUBLIC_URL}/driver/dashboard`}>
                                    <DropdownToggle caret className="btn-primary">
                                        <span className="menu-icon align-middle mr-75">
                                            <Icon.Home size={20} />
                                        </span>
                                        <span className="menu-title align-middle">Dashboard</span>
                                    </DropdownToggle>
                                </Link>
                            </div>
                        </li>
                    ) : (
                        ''
                    )}
                    {user_type === '1' || user_type === '3' || user_type === '5' ? (
                        <li
                            className={'nav-item ' + (currentPage === 'settings' ? 'active' : '')}
                            onMouseEnter={this.settingsToggle}
                            onMouseLeave={this.settingsToggle}
                        >
                            <div className="nav-item-wrapper cursor-pointer">
                                <Dropdown
                                    className="py-0"
                                    isOpen={this.state.settingsDropdown}
                                    toggle={this.settingsToggle}
                                >
                                    <DropdownToggle caret className="btn-primary">
                                        <span className="menu-icon align-middle mr-75">
                                            <Icon.Settings size={20} />
                                        </span>
                                        <span className="menu-title align-middle">Settings</span>
                                        <Icon.ChevronDown />
                                    </DropdownToggle>

                                    <DropdownMenu className="header-sub-menu">
                                        {user_type === '3' ? (
                                            <>
                                                <Link
                                                    onClick={this.mainMenuToggle}
                                                    to={`${process.env.PUBLIC_URL}/settings/users/add`}
                                                >
                                                    <DropdownItem className={subPage === 'users' ? 'active' : ''}>
                                                        <Icon.Plus size={14} />
                                                        <span className="menu-title align-middle">Add User</span>
                                                    </DropdownItem>
                                                </Link>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {user_type === '1' || user_type === '5' ? (
                                            <>
                                                <Link
                                                    onClick={this.mainMenuToggle}
                                                    to={`${process.env.PUBLIC_URL}/settings/update-product`}
                                                >
                                                    <DropdownItem
                                                        className={subPage === 'update-product' ? 'active' : ''}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            {/* <Update_Products className="icon-height" /> */}
                                                            <Icon.RefreshCcw size="12 " />
                                                            <span className="menu-title align-middle tab-icon-text ml-0">
                                                                Update Product
                                                            </span>
                                                        </div>
                                                    </DropdownItem>
                                                </Link>
                                                <Link
                                                    onClick={this.mainMenuToggle}
                                                    to={`${process.env.PUBLIC_URL}/settings/products`}
                                                >
                                                    <DropdownItem className={subPage === 'products' ? 'active' : ''}>
                                                        <Icon.Box size={12} />
                                                        <span className="menu-title align-middle">Products</span>
                                                    </DropdownItem>
                                                </Link>
                                                {user_type === '1' ? (
                                                    <>
                                                        <Link
                                                            onClick={this.mainMenuToggle}
                                                            to={`${process.env.PUBLIC_URL}/settings/categories`}
                                                        >
                                                            <DropdownItem
                                                                className={subPage === 'categories' ? 'active' : ''}
                                                            >
                                                                <Icon.Grid size={12} />
                                                                <span className="menu-title align-middle">
                                                                    Categories
                                                                </span>
                                                            </DropdownItem>
                                                        </Link>
                                                        <Link
                                                            onClick={this.mainMenuToggle}
                                                            to={`${process.env.PUBLIC_URL}/settings/brands`}
                                                        >
                                                            <DropdownItem
                                                                className={subPage === 'brands' ? 'active' : ''}
                                                            >
                                                                <Icon.Bold size={14} />
                                                                <span className="menu-title align-middle">Brands</span>
                                                            </DropdownItem>
                                                        </Link>
                                                    </>
                                                ) : (
                                                    ''
                                                )}
                                                <Link
                                                    onClick={this.mainMenuToggle}
                                                    to={`${process.env.PUBLIC_URL}/settings/users`}
                                                >
                                                    <DropdownItem className={subPage === 'users' ? 'active' : ''}>
                                                        <Icon.Users size={12} />
                                                        <span className="menu-title align-middle">Users</span>
                                                    </DropdownItem>
                                                </Link>

                                                {user_type === '1' ? (
                                                    <Link
                                                        onClick={this.mainMenuToggle}
                                                        to={`${process.env.PUBLIC_URL}/settings/company-setting`}
                                                    >
                                                        <DropdownItem
                                                            className={subPage === 'company-setting' ? 'active' : ''}
                                                        >
                                                            <Icon.Settings size={12} />
                                                            <span className="menu-title align-middle">
                                                                Company Setting
                                                            </span>
                                                        </DropdownItem>
                                                    </Link>
                                                ) : (
                                                    ''
                                                )}
                                                {user_type === '1' ? (
                                                    <>
                                                        <Link
                                                            onClick={this.mainMenuToggle}
                                                            to={`${process.env.PUBLIC_URL}/settings/email-templates`}
                                                        >
                                                            <DropdownItem
                                                                className={
                                                                    subPage === 'email-templates' ? 'active' : ''
                                                                }
                                                            >
                                                                <Icon.Mail size={12} />
                                                                <span className="menu-title align-middle">
                                                                    Email Templates
                                                                </span>
                                                            </DropdownItem>
                                                        </Link>
                                                        <Link
                                                            onClick={this.mainMenuToggle}
                                                            to={`${process.env.PUBLIC_URL}/settings/admin-documents`}
                                                        >
                                                            <DropdownItem
                                                                className={
                                                                    subPage === 'admin-documents' ? 'active' : ''
                                                                }
                                                            >
                                                                <Icon.File size={12} />
                                                                <span className="menu-title align-middle">
                                                                    Admin Documents
                                                                </span>
                                                            </DropdownItem>
                                                        </Link>
                                                        <Link
                                                            onClick={this.mainMenuToggle}
                                                            to={`${process.env.PUBLIC_URL}/settings/admin-notifications`}
                                                        >
                                                            <DropdownItem
                                                                className={
                                                                    subPage === 'admin-notifications' ? 'active' : ''
                                                                }
                                                            >
                                                                <div className="f-flex align-items-center">
                                                                    <Icon.Bell size={12} />
                                                                    <span className="menu-title align-middle">
                                                                        Notifications
                                                                    </span>
                                                                </div>
                                                            </DropdownItem>
                                                        </Link>
                                                    </>
                                                ) : (
                                                    ''
                                                )}
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        <Link
                                            onClick={this.mainMenuToggle}
                                            to={`${process.env.PUBLIC_URL}/settings/send-products`}
                                        >
                                            <DropdownItem className={subPage === 'send-products' ? 'active' : ''}>
                                                <Icon.Send size={12} />
                                                <span className="menu-title align-middle">Send Products</span>
                                            </DropdownItem>
                                        </Link>
                                        {user_type === '1' ? (
                                            <Link
                                                onClick={this.mainMenuToggle}
                                                to={`${process.env.PUBLIC_URL}/settings/discount`}
                                            >
                                                <DropdownItem className={subPage === 'discount' ? 'active' : ''}>
                                                    <Icon.Percent size={12} />
                                                    <span className="menu-title align middle">Discount</span>
                                                </DropdownItem>
                                            </Link>
                                        ) : (
                                            ''
                                        )}
                                        {user_type === '1' && (
                                            <Link
                                                onClick={this.mainMenuToggle}
                                                to={`${process.env.PUBLIC_URL}/settings/user-groups`}
                                            >
                                                <DropdownItem>
                                                    <Icon.Users size={12} />
                                                    <span className="menu-title align middle">User Groups</span>
                                                </DropdownItem>
                                            </Link>
                                        )}
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                        </li>
                    ) : (
                        ''
                    )}

                    <li
                        className={'ml-xl-1 nav-item ' + (currentPage === 'order' ? 'active' : '')}
                        onMouseEnter={this.orderToggle}
                        onMouseLeave={this.orderToggle}
                    >
                        <div className="nav-item-wrapper cursor-pointer">
                            <Dropdown className="py-0" isOpen={this.state.orderDropdown} toggle={this.orderToggle}>
                                <DropdownToggle caret className="btn-primary">
                                    <span className="menu-icon align-middle mr-75">
                                        <Icon.LifeBuoy size={20} />
                                    </span>
                                    <span className="menu-title align-middle">Order</span>
                                    <Icon.ChevronDown />
                                </DropdownToggle>
                                <DropdownMenu className="header-sub-menu">
                                    {user_type === '1' || user_type === '3' || user_type === '5' ? (
                                        <Link
                                            onClick={this.mainMenuToggle}
                                            to={`${process.env.PUBLIC_URL}/order/place-order`}
                                        >
                                            <DropdownItem className={subPage === 'place-order' ? 'active' : ''}>
                                                <Icon.ShoppingBag size={12} />
                                                <span className="menu-title align-middle">Place Order</span>
                                            </DropdownItem>
                                        </Link>
                                    ) : (
                                        ''
                                    )}
                                    {user_type === '1' || user_type === '5' ? (
                                        <Link to={`${process.env.PUBLIC_URL}/order/cart-list`}>
                                            <DropdownItem className={subPage === 'cart-list' ? 'active' : ''}>
                                                <Icon.Save size={12} />
                                                <span className="menu-title align-middle">Cart List</span>
                                            </DropdownItem>
                                        </Link>
                                    ) : (
                                        ''
                                    )}
                                    {user_type === '1' || user_type === '5' ? (
                                        <Link to={`${process.env.PUBLIC_URL}/order/buyer-cart-list`}>
                                            <DropdownItem className={subPage === 'buyer-cart-list' ? 'active' : ''}>
                                                <Icon.ShoppingCart size="12" />
                                                <span className="menu-title align-middle">Buyer Cart List</span>
                                            </DropdownItem>
                                        </Link>
                                    ) : (
                                        ''
                                    )}
                                    {user_type === '1' || user_type === '3' || user_type === '5' ? (
                                        <Link to={`${process.env.PUBLIC_URL}/order/order-history`}>
                                            <DropdownItem className={subPage === 'order-history' ? 'active' : ''}>
                                                <div className="d-flex align-items-center">
                                                    <Icon.Clock size="12" />
                                                    <span className="menu-title align-middle">Order History</span>
                                                </div>
                                            </DropdownItem>
                                        </Link>
                                    ) : (
                                        ''
                                    )}

                                    {user_type === '1' ? (
                                        <Link to={`${process.env.PUBLIC_URL}/order/invoice-history`}>
                                            <DropdownItem className={subPage === 'invoice-history' ? 'active' : ''}>
                                                <div className="d-flex align-items-center">
                                                    <Icon.Clock size={12} />
                                                    <span className="menu-title align-middle">Invoice History</span>
                                                </div>
                                            </DropdownItem>
                                        </Link>
                                    ) : (
                                        ''
                                    )}

                                    {user_type === '1' || user_type === '3' || user_type === '5' ? (
                                        <Link to={`${process.env.PUBLIC_URL}/order/buyer-order-history`}>
                                            <DropdownItem className={subPage === 'buyer-order-history' ? 'active' : ''}>
                                                <div className="d-flex align-items-center">
                                                    <Icon.Clock size={12} />
                                                    <span className="menu-title align-middle">Buyer Order History</span>
                                                </div>
                                            </DropdownItem>
                                        </Link>
                                    ) : (
                                        ''
                                    )}
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </li>

                    <li
                        className={'ml-xl-1 nav-item ' + (currentPage === 'cheque' ? 'active' : '')}
                        onMouseEnter={this.chequeToggle}
                        onMouseLeave={this.chequeToggle}
                    >
                        <div className="nav-item-wrapper cursor-pointer">
                            <Dropdown className="py-0" isOpen={this.state.chequeDropdown} toggle={this.chequeToggle}>
                                <DropdownToggle caret className="btn-primary">
                                    <span className="menu-icon align-middle mr-75">
                                        <Icon.LifeBuoy size={20} />
                                    </span>
                                    <span className="menu-title align-middle">Cheque</span>
                                    <Icon.ChevronDown />
                                </DropdownToggle>
                                <DropdownMenu className="header-sub-menu">
                                    {user_type === '1' || user_type === '5' ? (
                                        <Link to={`${process.env.PUBLIC_URL}/cheque/todays-collections`}>
                                            <DropdownItem className={subPage === 'todays-collections' ? 'active' : ''}>
                                                {/* {skin === "dark" ?
                          <img src={subPage === "todays-collections" ? Todays_Collection_icon : Todays_Collection_White_icon} className="horizontal-menu-icon" alt="Todays_Collection_White_icon" />
                          :
                          <img src={subPage === "todays-collections" ? Todays_Collection_Red_icon : Todays_Collection_Black_icon} className="horizontal-menu-icon" alt="Todays_Collection_White_icon" />
                        } */}
                                                <div className="d-flex align-items-center">
                                                    <Icon.Calendar size={13} />
                                                    {/* <Today_s_Collections
                            height="12"
                            width="12"
                            className=""
                            stroke="currentColor" strokeWidth="2"
                          /> */}
                                                    <span className="menu-title align-middle tab-icon-text ml-0">
                                                        Today's Collection
                                                    </span>
                                                </div>
                                            </DropdownItem>
                                        </Link>
                                    ) : (
                                        ''
                                    )}
                                    <Link to={`${process.env.PUBLIC_URL}/cheque/new-cheque`}>
                                        <DropdownItem className={subPage === 'new-cheque' ? 'active' : ''}>
                                            <Icon.CreditCard size={12} />
                                            <span className="menu-title align-middle">New Cheque</span>
                                        </DropdownItem>
                                    </Link>
                                    {user_type === '1' || user_type === '5' ? (
                                        <Link to={`${process.env.PUBLIC_URL}/cheque/cheque-list`}>
                                            <DropdownItem className={subPage === 'cheque-list' ? 'active' : ''}>
                                                <Icon.List size={12} />
                                                <span className="menu-title align-middle">Cheque List</span>
                                            </DropdownItem>
                                        </Link>
                                    ) : (
                                        ''
                                    )}
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </li>
                </ul>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        app: state.customizer,
    };
};
export default connect(mapStateToProps)(withRouter(HeaderNewMenu));
